export default function formatDate(dateString) {
    if (!dateString) return null;

    // Split the date string into parts
    const [year, month, day] = dateString.split('-').map(part => parseInt(part, 10));

    // Create a new Date object using the parts and set the time to noon to avoid time zone issues
    const date = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));

    // Check for invalid date
    if (isNaN(date.getTime())) {
        return null;
    }

    // Format the date to a human-readable string in Spanish
    return new Intl.DateTimeFormat('es', {
        month: 'long',
        day: '2-digit',
        year: 'numeric'
    }).format(date);
}

export function formatToValidDate(dateString) {
    const [day, month, year] = dateString.split('-');
    return `${year}-${month}-${day}`;
}

export function parseLocalDate(val) {
    if (!val) return null;
    if (val instanceof Date) {
        if (isNaN(val.getTime())) return null;
        if (
            val.getUTCHours() === 0 &&
            val.getUTCMinutes() === 0 &&
            val.getUTCSeconds() === 0 &&
            val.getTimezoneOffset() !== 0 &&
            (val.getHours() !== 0 || val.getMinutes() !== 0)
        ) {
            return new Date(val.getUTCFullYear(), val.getUTCMonth(), val.getUTCDate());
        }
        return val;
    }
    if (typeof val === 'string') {
        const trimmed = val.trim();
        if (!trimmed) return null;
        const match = trimmed.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
        if (match) {
            return new Date(parseInt(match[1], 10), parseInt(match[2], 10) - 1, parseInt(match[3], 10));
        }
        const d = new Date(trimmed);
        if (isNaN(d.getTime())) return null;
        if (
            d.getUTCHours() === 0 &&
            d.getUTCMinutes() === 0 &&
            d.getUTCSeconds() === 0 &&
            d.getTimezoneOffset() !== 0 &&
            (d.getHours() !== 0 || d.getMinutes() !== 0)
        ) {
            return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        }
        return d;
    }
    return null;
}

export function formatDateToYMD(date) {
    if (!date) return '';
    if (typeof date === 'string') {
        const match = date.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
        if (match) {
            const m = match[2].padStart(2, '0');
            const d = match[3].padStart(2, '0');
            return `${match[1]}-${m}-${d}`;
        }
        const parsed = new Date(date);
        if (isNaN(parsed.getTime())) return '';
        date = parsed;
    }
    if (date instanceof Date && !isNaN(date.getTime())) {
        if (
            date.getUTCHours() === 0 &&
            date.getUTCMinutes() === 0 &&
            date.getUTCSeconds() === 0 &&
            date.getTimezoneOffset() !== 0 &&
            (date.getHours() !== 0 || date.getMinutes() !== 0)
        ) {
            const year = date.getUTCFullYear();
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');
            const day = String(date.getUTCDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    return '';
}